// Runtime configuration from /config.js, so one build serves every
// environment. Local defaults live in public/config.js.
interface RuntimeConfig {
  // Where /auth and /v1 are served: empty, this origin (the deploys route
  // them here, and locally nginx or Vite proxy them), so the session cookies
  // are this site's alone.
  apiUrl: string;
  // Sign-in methods beside the emailed code. Each shows once the API has the
  // provider's credentials.
  googleEnabled: boolean;
  appleEnabled: boolean;
  // Local only: the one account the API signs in with a fixed code, no email
  // sent. Empty everywhere else, which hides the button.
  devEmail?: string;
  devCode?: string;
}

declare global {
  interface Window {
    __WELLREAD__?: Partial<RuntimeConfig>;
  }
}

const raw = window.__WELLREAD__ ?? {};

export const config: RuntimeConfig = {
  apiUrl: (raw.apiUrl ?? '').replace(/\/$/, ''),
  googleEnabled: raw.googleEnabled === true,
  appleEnabled: raw.appleEnabled === true,
  devEmail: raw.devEmail ?? '',
  devCode: raw.devCode ?? '',
};
